import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "picker-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_color_picker = _resolveComponent("v-color-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    class: "color-picker__wrapper",
    absolute: ""
  }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("div", _mergeProps({ class: "color-picker" }, props), [
        _createElementVNode("div", {
          class: "palette",
          style: _normalizeStyle(_ctx.paletteStyle)
        }, null, 4)
      ], 16)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_color_picker, {
          elevation: "8",
          "hide-canvas": "",
          "hide-inputs": "",
          "hide-mode-switch": "",
          "hide-sliders": "",
          mode: "rgba",
          "show-swatches": "",
          "swatches-max-height": "200",
          "model-value": _ctx.modelValue,
          "onUpdate:modelValue": _ctx.onColorInput
        }, null, 8, ["model-value", "onUpdate:modelValue"])
      ])
    ]),
    _: 1
  }))
}